import React, { Fragment } from 'react'
import useStyles from './styles'
import Typography from '@material-ui/core/Typography'
import lottie404 from 'assets/404-lottie.json'

const NotFound = () => {
  const classes = useStyles()
  return (
    <Fragment>
      <section className={classes.notFound}>
        <lottie-player
          src={JSON.stringify(lottie404)}
          background="transparent"
          speed="1"
          autoplay
          loop
          style={{
            width: '320px',
            height: '320px',
            marginTop: '-100px',
            marginBottom: '24px'
          }}
        />
        <div className={classes.text}>
          <Typography variant="h2" className={classes.display}>
            Looks like you got lost
          </Typography>
          <Typography variant="subtitle1">
            Sorry about that, check the URL and make sure you didn't make a
            mistake, or refresh and try again
          </Typography>
        </div>
      </section>
    </Fragment>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.jsx